var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    [
      _c(
        "template",
        { slot: "header" },
        [_c("Title", { attrs: { title: "Pedidos pendentes de pagamento" } })],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "body" }, [
        _c(
          "div",
          [
            _vm._l(_vm.cycles, function(cycle) {
              return _c("CycleCard", {
                key: cycle.id,
                attrs: { payable: cycle }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.orders, function(order) {
              return _c("OrderCard", {
                key: order.id,
                attrs: { payable: order }
              })
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("Tip", [
            _vm._v(
              "Selecione o pedido ou assinatura que você deseja realizar o pagamento"
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn bg-purple",
              on: {
                click: function($event) {
                  _vm.$emit("close")
                }
              }
            },
            [_c("span", [_vm._v("Voltar")])]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f1ce6a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f1ce6a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/components/Payables/PendingPayablesList.vue
// module id = null
// module chunks = 